import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import axios from "axios";
import { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { CountriesContext } from "../contexts/countriescontexts";
export default function Right({ ss, setss }) {
  const [c1, setc1] = useState([]);
  const [c2, setc2] = useState([]);
  const [c3, setc3] = useState([]);
  const { s, sets } = useContext(CountriesContext);
 
   useEffect(() => {
      const sevedc1=localStorage.getItem("c1");
      if(sevedc1){
        setc1(JSON.parse(sevedc1))
      }
      else{
      axios
        .get(
          "https://restcountries.com/v3.1/all?fields=name,capital,currencies"
        )
        .then(function (response) {
          const arr=response.data.map((i)=>i.name.common)
          setc1(arr)
          localStorage.setItem("c1",JSON.stringify(arr))
          
 
        });
      }
    
  }, []); 
  useEffect(() => {

 
      for (let i in c1) {
        axios
          .get(`https://restcountries.com/v3.1/name/${c1[i]}`)
          .then(function (response1) {
            setc2((p) => [...p, response1]); 
          });
        }  
      console.log(c1, "c1");
      setss(c1);
    
  }, [c1]);

  useEffect(() => {
   
    setc3([
      c2.map((i) => {
        return (
          <div
            key={uuid()}
            style={{
              margin: "1%",
              width: "30%",
              height: "30%",
              display: "inline-block",
              border: "5px black inset",
              borderRadius: "10%",
              overflow: "hidden",
              color: "white",
            }}
          >
            <div
              style={{
                background: `url(${i.data[0].flags.png}) center`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                width: "100%",
                height: "70%",
              }}
            ></div>
            <div
              style={{
                height: "30%",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                background: "rgb(19, 44, 140)",
                padding: "0 5%",
                gap: "10%",
              }}
            >
              <img
                src={i.data[0].coatOfArms.png}
                style={{ width: "20%", height: "100%", margin: "30% 0" }}
              ></img>
              <h3>{i.data[0].fifa}</h3>
              <h3> {i.data[0].translations.ara.official}</h3>
              <Link to={"/search"}>
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    width: "30%",
                    background: "red",
                    transition: "all ease-in-out .3s",
                  }}
                  className={"more"}
                  onClick={() => {
                    sets(i.data[0].name.common);
                  }}
                >
                  More
                </Button>
              </Link>
            </div>
          </div>
        );
      }),
    ]);
  }, [c2]);
  return (
    <div
      style={{
        transition: "all .9s ease-in-out ",
        width: "100%",
        height: "97%",
        overflowX: "hidden",
        overflowY: "scroll",
        display: "flex",
        padding: "20px ",
        scrollbarWidth: "auto",
        background: "purple",
      }}
    >
      <div style={{ width: "100%", display: "inline" }}> {c3}</div>
    </div>
  );
}
